





import Vue from "vue";
import { VSelect } from "vuetify/lib";
export default Vue.extend({
  name: "base-select",
  mixins: [VSelect],
  props: {
    uriKey: {
      type: String,
    },
    type: {
      type: String,
    },
  },
  computed: {
    computedProps(): Record<string, any> {
      const props = { ...this.$props };
      return props;
    },
  },
  //  mounted() {
  //    this.$emit("input", this.$route.query[this.uriKey]);
  //  },
  watch: {
    computedProps: {
      handler(props) {
        if (this.uriKey && this.$route.query[this.uriKey] != props.value) {
          const query = {} as any;
          query[this.uriKey] = props.value;
          this.$router.push({ query });
        }
      },
      deep: true,
    },
  },
});
